export default {
    EXAME_LABORATORIAL: 1,
    EXAME_IMAGEM: 2
}